// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2rEWs","icon":"style_icon__EJ9Uq"};